import { useSelector, shallowEqual } from 'react-redux';

import { PREFERRED_COMMUNICATION_METHOD } from 'config/app-config';
import { selectDetails as selectAccountDetails } from 'state/account/account-slice';

export const usePaperLessBilling = () => {
  const account = useSelector(selectAccountDetails, shallowEqual);
  return (
    account.preferredCommunicationMethod ===
    PREFERRED_COMMUNICATION_METHOD.EMAIL
  );
};
